import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Briefcase, Factory } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

const OPTIONS = [
  ["executive", Briefcase, "Executive Briefing", "AI Strategy for Industrial Leaders · 9 short sessions · ~90 minutes · 10-question leader quiz"],
  ["strategist", Factory, "Certified Industrial AI Strategist", "Full programme · 3 days · 8 modules · 3 credentials · pilot brief"],
];

export default function ChooseTrack() {
  const { refreshMe } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const pick = async (track) => {
    setBusy(true);
    try {
      await api.patch("/auth/track", { track });
      await refreshMe();
      navigate("/dashboard", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e));
      setBusy(false);
    }
  };
  return (
    <main className="mx-auto max-w-4xl px-4 py-16 sm:px-8">
      <div className="overline-label">Welcome</div>
      <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter">Choose your path</h1>
      <p className="mt-3 text-muted-foreground">You can change this later from your profile menu.</p>
      <div className="mt-10 grid gap-4 md:grid-cols-2">
        {OPTIONS.map(([track, Icon, title, body]) => (
          <button key={track} type="button" disabled={busy} onClick={() => pick(track)} data-testid={`choose-track-${track}`} className="border border-border bg-card p-8 text-left transition-transform hover:-translate-y-0.5 disabled:opacity-60">
            <Icon className="h-6 w-6 text-brand-primary" />
            <div className="mt-4 font-heading text-2xl font-bold">{title}</div>
            <p className="mt-2 text-sm text-muted-foreground">{body}</p>
          </button>
        ))}
      </div>
    </main>
  );
}
